export default {
	ws_url: 'wss://manote.pentium02.org/ws',
	tracks_url: 'https://manote.pentium02.org/storage/',
	ping_interval: 60000,	
}



// WEBPACK FOOTER //
// ./src/config.js